import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { PoliciesRoutes } from "../../../routes/HomeRoutes/PoliciesRoutes";

export const PoliciesLayout = () => (
    <SwitchRoute routes={PoliciesRoutes}/>
);